import { render } from "./ButtonVbind.vue?vue&type=template&id=3a5be4a2"
import script from "./ButtonVbind.vue?vue&type=script&lang=js"
export * from "./ButtonVbind.vue?vue&type=script&lang=js"

import "./ButtonVbind.vue?vue&type=style&index=0&id=3a5be4a2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__